import Vue from 'vue'

import Vuex from 'vuex'
import {state, getters, mutations, actions} from './store'

import App from './App.vue'
import router from './router'
import './assets/tailwind.css'
Vue.config.productionTip = false

Vue.use(Vuex)

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
